import { render, staticRenderFns } from "./CommunityFilterPillsList.vue?vue&type=template&id=72c57d2d&scoped=true&"
import script from "./CommunityFilterPillsList.vue?vue&type=script&lang=js&"
export * from "./CommunityFilterPillsList.vue?vue&type=script&lang=js&"
import style0 from "./CommunityFilterPillsList.vue?vue&type=style&index=0&id=72c57d2d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72c57d2d",
  null
  
)

export default component.exports